import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux'
import { Trans, useTranslation } from 'react-i18next';

import Alert from '@material-ui/lab/Alert';
import ErrorIcon from '@material-ui/icons/Error';
import Snackbar from '@material-ui/core/Snackbar';
import SupportButton from 'cityads-v3/components/Buttons/SupportButton';

import classes from './IsBannedUser.scss';

export default function IsBannedUser() {
  const { t } = useTranslation(['main']);
  const isBanned = useSelector(state => state.auth.user?.isBanned);

  const [open, setOpen] = useState(true);

  const handleClose = useCallback(() => setOpen(false), [setOpen]);

  if (!isBanned) {
    return null;
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
    >
      <Alert severity="error" variant="filled" icon={<ErrorIcon fontSize="inherit" />} onClose={handleClose} className={classes.alert}>
        <Trans t={t} i18nKey={'isBannedUserText'} parent="span">
          Your account is blocked. Please, contact your manager or
          to <SupportButton component="span" role="button" className={classes.support}>technical support</SupportButton>.
        </Trans>
      </Alert>
    </Snackbar>
  );
}
